module.exports = __webpack_public_path__ + "img/Letter_board.4804be1.jpg";